(function () {
  const searchableFields = [
    'title',
    'body',
    'product_type',
    'tag',
    'variants.sku',
    'variants.title',
  ];

  function buildSearchQuery(terms) {
    const tokens = terms.trim().match(/"[^"]*"|\S+/g) || [];

    return tokens
      .map((token) => token.replace(/^"|"$/g, ''))
      .filter(Boolean)
      .map((token) => {
        const escapedToken = token
          .replace(/\\/g, '\\\\')
          .replace(/"/g, '\\"');
        const fieldQueries = searchableFields
          .map((field) => `${field}:"${escapedToken}"`)
          .join(' OR ');

        return `(${fieldQueries})`;
      })
      .join(' AND ');
  }

  window.GraystoneSearchFields = {
    buildQuery: buildSearchQuery,
  };
}());
